import React, { useMemo } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

// Renders a string that may contain inline LaTeX wrapped in single $...$.
export default function MathText({ text, className = "", block = false }) {
  const parts = useMemo(() => splitMath(String(text ?? "")), [text]);
  return (
    <span className={className} data-testid="math-text">
      {parts.map((p, i) =>
        p.math ? (
          <span
            key={i}
            dangerouslySetInnerHTML={{
              __html: safeRender(p.value, block),
            }}
          />
        ) : (
          <span key={i}>{p.value}</span>
        )
      )}
    </span>
  );
}

function splitMath(text) {
  const out = [];
  const regex = /\$([^$]+)\$/g;
  let last = 0;
  let m;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) out.push({ math: false, value: text.slice(last, m.index) });
    out.push({ math: true, value: m[1] });
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push({ math: false, value: text.slice(last) });
  return out;
}

function safeRender(tex, block) {
  try {
    return katex.renderToString(tex, { throwOnError: false, displayMode: block });
  } catch {
    return tex;
  }
}
